import { render, staticRenderFns } from "./AppointmentsAuthorizeModal.vue?vue&type=template&id=28afde0d&"
import script from "./AppointmentsAuthorizeModal.vue?vue&type=script&lang=js&"
export * from "./AppointmentsAuthorizeModal.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentsAuthorizeModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports